// src/AppBanner.js
// Баннер «Приложение в RuStore». Включает и настраивает его только hlpurslf
// (вкладка «Баннер» в админ-панели, сервер проверяет права сам).
//   variant="login" — под окном входа, закрыть нельзя;
//   variant="top"   — полоса над шапкой сайта с крестиком; закрытие запоминается
//                     по номеру версии, поэтому изменённый баннер покажется снова.
// На iPhone и iPad баннер не показываем: RuStore есть только для Android.
import React, { useEffect, useState } from 'react';
import { api } from './api';
import './AppBanner.css';
import appIcon from './assets/app-icon-192.png';

const DISMISSED_KEY = 'eu_app_banner_dismissed';

const isAppleMobile = () =>
  /iPhone|iPad|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const readDismissed = () => {
  try {
    return Number(localStorage.getItem(DISMISSED_KEY)) || 0;
  } catch {
    return 0;
  }
};

// Знак RuStore (из RuStore_Color_Logo.svg). На синей кнопке синий квадрат слился бы
// с фоном, поэтому знак инвертирован: белый квадрат, синий символ.
function RuStoreMark() {
  return (
    <svg className="eu-appcard-store" viewBox="218 218 356.668 358" aria-hidden="true">
      <path fill="#ffffff" d="M243.072 550.834C268.144 576 308.496 576 389.2 576H403.467C484.172 576 524.524 576 549.596 550.834C574.668 525.669 574.668 485.166 574.668 404.159V389.839C574.668 308.833 574.668 268.329 549.596 243.164C524.524 218 484.172 218 403.467 218H389.2C308.496 218 268.144 218 243.072 243.164C218 268.329 218 308.833 218 389.839V404.159C218 485.166 218 525.669 243.072 550.834Z" />
      <path fill="#0077FF" fillRule="evenodd" clipRule="evenodd" d="M493.368 455.955L469.269 449.912C466.367 449.077 464.318 446.456 464.215 443.409L461.207 354.38C460.337 342.596 451.623 333.224 442.516 330.464C442.005 330.309 441.459 330.518 441.156 330.96C440.848 331.408 440.967 332.029 441.396 332.363C443.645 334.11 449.835 339.812 449.835 349.648L449.817 466.052C449.817 477.292 439.235 485.535 428.32 482.798L403.849 476.662C401.135 475.709 399.251 473.173 399.152 470.247L396.145 381.212C395.275 369.428 386.56 360.056 377.453 357.296C376.942 357.141 376.396 357.35 376.093 357.791C375.786 358.24 375.904 358.861 376.334 359.194C378.583 360.942 384.772 366.644 384.772 376.479L384.754 473.508L384.767 473.51V492.894C384.767 504.134 374.186 512.378 363.271 509.641L294.15 492.31C284.541 489.9 277.803 481.272 277.803 471.376L277.803 354.791C277.803 343.551 288.384 335.307 299.299 338.044L342.852 348.965V327.948C342.852 316.708 353.434 308.465 364.349 311.201L407.9 322.121V301.105C407.9 289.864 418.481 281.621 429.396 284.358L498.517 301.689C508.126 304.098 514.864 312.726 514.864 322.622V439.208C514.864 450.448 504.283 458.691 493.368 455.955Z" />
    </svg>
  );
}

// Сам баннер без загрузки — используется и в предпросмотре админки
export function AppBannerView({ banner, variant, onClose }) {
  return (
    <aside className={`eu-appcard eu-appcard-${variant}`} aria-label="Мобильное приложение">
      <img className="eu-appcard-icon" src={appIcon} alt="" width="44" height="44" />
      <span className="eu-appcard-text">
        <strong className="eu-appcard-title">{banner.title}</strong>
        <span className="eu-appcard-subtitle">{banner.text}</span>
      </span>
      <a className="eu-appcard-button" href={banner.url || '#'} target="_blank" rel="noopener noreferrer">
        <RuStoreMark />
        {banner.button_label}
      </a>
      {onClose && (
        <button type="button" className="eu-appcard-close" onClick={onClose} aria-label="Скрыть баннер">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </aside>
  );
}

export default function AppBanner({ variant = 'top', refreshKey = 0 }) {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(readDismissed);

  useEffect(() => {
    if (isAppleMobile()) return undefined;
    let alive = true;
    api.getAppBanner().then((data) => alive && setBanner(data), () => {});
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  if (!banner || !banner.enabled || !banner.url) return null;
  if (variant === 'top' && dismissed >= banner.version) return null;

  const close = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, String(banner.version));
    } catch {
      // не запомним — покажется снова после перезагрузки
    }
    setDismissed(banner.version);
  };

  return <AppBannerView banner={banner} variant={variant} onClose={variant === 'top' ? close : null} />;
}
